/********************************************************************************
 * Copyright (c) 2022 Cedalo GmbH
 *
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the Eclipse Public License 2.0 which accompany this distribution.
 * and Eclipse Distribution License v1.0 which accompany this distribution.
 *
 * The Eclipse Public License is available at
 *   https://www.eclipse.org/legal/epl-2.0/
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import JSG from '@cedalo/jsg-ui';

const moveSheet = (sheetsContainer, fromIndex, toIndex) => {
	const streamsheets = sheetsContainer.streamSheetsModel || [];
	const sheetorder = streamsheets.map((sheet) => sheet.properties.sheetId);
	const removed = sheetorder.splice(fromIndex, 1);
	if (removed.length) sheetorder.splice(toIndex, 0, removed[0]);
	sheetsContainer.setStreamSheetsOrder(sheetorder);
};

export default class MoveSheetCommand extends JSG.Command {
	constructor(sheetsContainer, fromIndex, toIndex) {
		super();
		this.toIndex = toIndex;
		this.fromIndex = fromIndex;
		this.sheetsContainer = sheetsContainer;
	}

	execute() {
		this.redo();
	}

	undo() {
		moveSheet(this.sheetsContainer, this.toIndex, this.fromIndex);
	}

	redo() {
		moveSheet(this.sheetsContainer, this.fromIndex, this.toIndex);
	}
}
